import React from "react";
import { CheckBalanceStepModel } from "../../../models/CheckBalanceStep.model";
import { CustomizeStepModel } from "../../../models/CustomizeStep.model";
import { RecipientsStepModel } from "../../../models/RecipientsStep.model";
import { RegiftCardStepModel } from "../../../models/RegiftCardStep.model";
import { RegiftPaymentStepModel } from "../../../models/RegiftPaymentStep.model";
import { WorkflowTypeEnum } from "../../../models/enums/WorkflowTypeEnum";
import { RegiftCardContext } from "../../../pages/RegiftCardPage";
import LoadingComponent from "../../shared/LoadingComponent";

interface IDebugRegiftDataPreivewComponentProps {
    isSaving: boolean;
    isLoading: boolean;
}

const DebugRegiftDataPreivewComponent = (props: IDebugRegiftDataPreivewComponentProps) => {

    const { id, currentState, checkBalanceStep, regiftCardStep, recipientsStep, customizeStep, paymentStep, isValid } = React.useContext(RegiftCardContext);

    const cardBalance = checkBalanceStep ? checkBalanceStep.remainingBalance : 0;
    const checkBalanceStepIsValid = (checkBalanceStep && CheckBalanceStepModel.validateModel(checkBalanceStep));
    const regiftCardStepIsValid = (checkBalanceStep && RegiftCardStepModel.validateModel(regiftCardStep, cardBalance));
    const recipientsStepIsValid = (recipientsStep && RecipientsStepModel.validateModel(recipientsStep, WorkflowTypeEnum.REGIFT_CARD));
    const customizeStepIsValid = (customizeStep && CustomizeStepModel.validateModel(customizeStep));
    const paymentStepIsValid = (paymentStep && RegiftPaymentStepModel.validateModel(paymentStep));

    return (
        <>
            {(props.isSaving || props.isSaving) ? (
                <LoadingComponent />
            ) : (
                <div className='my-card box' style={{ backgroundColor: '#00FF00', padding: '15px' }}>
                    <h2>DEV TESTING (REGIFT)</h2>
                    <h4>GLOBAL STATE</h4>
                    <p style={{ "color": "black" }}>Basket Id: <b>{id}</b></p>
                    <p style={{ "color": "black" }}>State: <strong>{currentState}</strong></p>
                    <br />

                    <div>
                        <h3>Step 1 - Check my balance</h3>
                        <p>card code: {checkBalanceStep.giftCardCode}</p>
                        <p>balance: {checkBalanceStep.remainingBalance}</p>
                        <p>Currency: {checkBalanceStep.currencySymbol}</p>

                        <br />
                        <p>Is Dirty: {String(checkBalanceStep.isDirty)}</p>
                        <p>Is Valid: {checkBalanceStepIsValid && "VALID"} {!checkBalanceStepIsValid && "INVALID"}</p>
                        <br />
                    </div>

                    <div>
                        <h3>Step 2 - Regift my card</h3>
                        <p>Value: {regiftCardStep.value}</p>

                        <br />
                        <p>Is Dirty: {String(regiftCardStep.isDirty)}</p>
                        <p>Is Valid: {regiftCardStepIsValid && "VALID"} {!regiftCardStepIsValid && "INVALID"}</p>
                        <br />
                    </div>


                    <div>
                        <h3>Step 3 - Recipients</h3>
                        <p>total: {recipientsStep.recipients.length}</p>
                        <p>sendBy: {recipientsStep.sendBy}</p>
                        <p>sendIndividually: {String(recipientsStep.sendIndividually)}</p>
                        <p>sendItLater: {String(recipientsStep.sendItLater)}</p>
                        <p>senderSameAsRecipient: {String(recipientsStep.senderSameAsRecipient)}</p>
                        {recipientsStep.recipients.length > 0 &&
                            <>
                                <p>Recepient 1:</p>
                                <p>{`${recipientsStep.recipients[0].firstName} ${recipientsStep.recipients[0].lastName} (${recipientsStep.recipients[0].email})`}</p>
                            </>}
                        <p>Sender:</p>
                            <p>{`${recipientsStep.sender.firstName} ${recipientsStep.sender.lastName} (${recipientsStep.sender.email}, ${recipientsStep.sender.email})`}</p>

                        <br />
                        <p>Is Dirty: {String(recipientsStep.isDirty)}</p>
                        <p>Is Valid: {recipientsStepIsValid && "VALID"} {!recipientsStepIsValid && "INVALID"}</p>
                        <br />
                    </div>

                    <div>
                        <h3>Step 4 - Customize Step</h3>
                        <p>Template Url: {customizeStep.giftCardUrl}</p>
                        <p>GIF Url: {customizeStep.mediaUrl}</p>
                        <p>Message: {customizeStep.personalMessage}</p>
                        <br />
                        <p>Is Dirty: {String(customizeStep.isDirty)}</p>
                        <p>Is Valid: {customizeStepIsValid && "VALID"} {!customizeStepIsValid && "INVALID"}</p>
                        <br />
                    </div>

                    <div>
                        <h3>Step 5 - Review And Pay</h3>


                        <p>Terms Accepted: {String(paymentStep.termsAccepted)}</p>

                        <br />
                        <p>Is Dirty: {String(paymentStep.isDirty)}</p>
                        <p>Is Valid: {paymentStepIsValid && "VALID"} {!paymentStepIsValid && "INVALID"}</p>
                        <br />
                    </div>

                </div>
            )}

        </>
    );
};
export default DebugRegiftDataPreivewComponent;